var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "", md4: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [_vm._v("Qui ?")])
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isTenantAndOwner && !_vm.isServiceBookUser
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: { label: _vm.lblSetting.ticketOriginOfTheDeclaration }
                },
                [
                  _c("ticket-origin-demand", {
                    attrs: { disabled: _vm.toUpdate },
                    model: {
                      value: _vm.OriginDemand,
                      callback: function($$v) {
                        _vm.OriginDemand = $$v
                      },
                      expression: "OriginDemand"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.select_declarant
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: { required: "", label: _vm.lblSetting.ticketDeclarer }
                },
                [
                  _c("base-multi-select", {
                    key: 1,
                    attrs: {
                      rules: _vm.dtRules.ticketDeclarerRules,
                      options: _vm.coDeclarant,
                      "item-value": "id",
                      disabled: _vm.toUpdate,
                      "return-object": true,
                      multiple: false,
                      fetch: _vm.handleGetDeclarants
                    },
                    on: { change: _vm.handleChangeDeclarant },
                    model: {
                      value: _vm.Declarant,
                      callback: function($$v) {
                        _vm.Declarant = $$v
                      },
                      expression: "Declarant"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isServiceBook
            ? [
                _c(
                  "base-control-label-vertical",
                  {
                    attrs: {
                      required: "",
                      label: _vm.isServiceBookUser
                        ? "Adresse"
                        : _vm.lblSetting.ticketImmeuble
                    }
                  },
                  [
                    _c("base-multi-select", {
                      key: 2,
                      attrs: {
                        rules: _vm.dtRules.ticketFkTicketBlockRules,
                        icon: "icon icon-blocks",
                        "item-value": "value",
                        options: _vm.coBlocks,
                        fetch: _vm.handleFetchBlocks,
                        disabled: _vm.toUpdate,
                        "return-object": false,
                        multiple: false
                      },
                      on: { change: _vm.handleChangeBlock },
                      model: {
                        value: _vm.FkTicketBlock,
                        callback: function($$v) {
                          _vm.FkTicketBlock = $$v
                        },
                        expression: "FkTicketBlock"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.coApartments.length
                  ? _c(
                      "base-control-label-vertical",
                      {
                        attrs: {
                          required:
                            _vm.pbType === "private" &&
                            _vm.$route.meta.select_ticket_pb_type === true,
                          label: _vm.isServiceBookUser
                            ? "Lot"
                            : _vm.lblSetting.ticketAppartement
                        }
                      },
                      [
                        _c("base-autocomplete", {
                          attrs: {
                            items: _vm.coApartments,
                            "on-fetch-remote": _vm.handleGetApartments,
                            multiple: true,
                            disabled: _vm.toUpdate,
                            "return-object": false,
                            clearable:
                              _vm.pbType === "internal" ||
                              _vm.pbType === "public",
                            rules: _vm.apartmentRules,
                            "item-value": "value"
                          },
                          on: { change: _vm.handleChangeApartment },
                          model: {
                            value: _vm.TicketApartments,
                            callback: function($$v) {
                              _vm.TicketApartments = $$v
                            },
                            expression: "TicketApartments"
                          }
                        }),
                        _vm._v(" "),
                        _vm.$route.meta &&
                        _vm.$route.meta["force_external_apartment"] &&
                        !_vm.toUpdate
                          ? _c("v-switch", {
                              staticClass: "apartment-switcher",
                              attrs: {
                                color: "primary",
                                label: _vm.$t(
                                  _vm.lblSetting.ticketAppartmentHorsImmeuble
                                )
                              },
                              model: {
                                value: _vm.excludeBlock,
                                callback: function($$v) {
                                  _vm.excludeBlock = $$v
                                },
                                expression: "excludeBlock"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.hadApartment &&
          _vm.$route.meta.apartment_zone_allowed &&
          _vm.coZones.length
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.ticketZone } },
                [
                  _c("base-autocomplete", {
                    attrs: {
                      items: _vm.coZones,
                      "on-fetch-remote": _vm.handleSearchZone,
                      multiple: "",
                      "return-object": false,
                      clearable: "",
                      "item-value": "value"
                    },
                    on: { change: _vm.handleChangeZone },
                    model: {
                      value: _vm.Zones,
                      callback: function($$v) {
                        _vm.Zones = $$v
                      },
                      expression: "Zones"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.assign_manager
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    required: "",
                    label: _vm.lblSetting.ticketManagerAssign
                  }
                },
                [
                  _c("base-multi-select", {
                    key: 3,
                    attrs: {
                      rules: _vm.dtRules.ticketFkTicketManagerRules,
                      options: _vm.coManagers,
                      "return-object": false,
                      fetch: _vm.handleGetManagers,
                      disabled: _vm.toUpdate
                    },
                    model: {
                      value: _vm.Managers,
                      callback: function($$v) {
                        _vm.Managers = $$v
                      },
                      expression: "Managers"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-3" }, [
                    _vm.coIsManager && !_vm.coIsAssigned && !_vm.toUpdate
                      ? _c("a", {
                          staticClass: "form-container__button--no-decoration",
                          attrs: { href: "javascript:;", flat: "" },
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(_vm.lblSetting.ticketAssignMe)
                            )
                          },
                          on: { click: _vm.handleAssignMe }
                        })
                      : _vm._e()
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.add_tenant
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.ticketParticipants } },
                [
                  _c("base-multi-select", {
                    key: 4,
                    attrs: {
                      options: _vm.coParticipants,
                      "return-object": true,
                      multiple: true,
                      fetch: _vm.handleGetParticipants,
                      disabled: !_vm.hadBlock || _vm.toUpdate
                    },
                    on: { change: _vm.handleChangeParticipants },
                    model: {
                      value: _vm.Participants,
                      callback: function($$v) {
                        _vm.Participants = $$v
                      },
                      expression: "Participants"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-3": "", xs12: "", md4: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [_vm._v("Quoi ?")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { required: "", label: _vm.lblSetting.ticketName } },
            [
              _c("v-text-field", {
                attrs: {
                  counter: _vm.textConfigs.input,
                  maxlength: _vm.textConfigs.input,
                  required: "",
                  rules: _vm.dtRules.nameRules,
                  solo: ""
                },
                model: {
                  value: _vm.Subject,
                  callback: function($$v) {
                    _vm.Subject = $$v
                  },
                  expression: "Subject"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta.select_ticket_pb_type &&
          _vm.displayTypesOfProblem &&
          _vm.pbType !== "maint_auto"
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    required: "",
                    label: _vm.lblSetting.ticketTypeOfProblem
                  }
                },
                [
                  _c("ticket-group-round-buttons", {
                    attrs: { buttons: _vm.typesOfTheProblems },
                    on: { onChange: _vm.handlePbTypeChange },
                    model: {
                      value: _vm.pbType,
                      callback: function($$v) {
                        _vm.pbType = $$v
                      },
                      expression: "pbType"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.select_ticket_priority
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    required: "",
                    label: _vm.lblSetting.ticketPriorityLevel
                  }
                },
                [
                  _c("base-multi-select", {
                    attrs: {
                      required: "",
                      rules: _vm.dtRules.ticketFkTicketPriorityLevelRules,
                      options: _vm.coTicketPriorityLevels,
                      icon: "",
                      "item-value": "id",
                      "item-text": "name",
                      multiple: false
                    },
                    model: {
                      value: _vm.FKTicketPriorityLevel,
                      callback: function($$v) {
                        _vm.FKTicketPriorityLevel = $$v
                      },
                      expression: "FKTicketPriorityLevel"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.coTicketSubstatus.length
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.ticketSubstatus } },
                [
                  _c("base-multi-select", {
                    attrs: {
                      options: _vm.coTicketSubstatus,
                      icon: "",
                      "item-value": "id",
                      "item-text": "name",
                      multiple: false
                    },
                    model: {
                      value: _vm.FKTicketSubstatus,
                      callback: function($$v) {
                        _vm.FKTicketSubstatus = $$v
                      },
                      expression: "FKTicketSubstatus"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.select_ticket_char_pb
            ? _c(
                "div",
                [
                  _vm.$route.meta.char_pb_2_allow
                    ? _c(
                        "div",
                        [
                          _c(
                            "base-control-label-vertical",
                            {
                              attrs: {
                                required: _vm.$route.meta.char_pb_1_required,
                                label:
                                  "" +
                                  _vm.$t(
                                    _vm.lblSetting.ticketNatureOfTheProblem
                                  )
                              }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  rules:
                                    _vm.dtRules
                                      .ticketFkTicketCharacterProblemsRules_1,
                                  "item-value": "id",
                                  "item-text": "name",
                                  items: _vm.characterProblems.level_1,
                                  solo: ""
                                },
                                on: { change: _vm.handleChangeCharPb1 },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return _c(
                                        "v-chip",
                                        {
                                          staticClass: "chip--select-multi",
                                          attrs: {
                                            close: "",
                                            color: "secondary",
                                            "text-color": "whitePure"
                                          },
                                          on: { input: _vm.handleRemoveCharPb1 }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "multiple-selected-item",
                                              staticStyle: { width: "160px" }
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(data.item.name)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.FKTicketCharacterProblem,
                                  callback: function($$v) {
                                    _vm.FKTicketCharacterProblem = $$v
                                  },
                                  expression: "FKTicketCharacterProblem"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "base-control-label-vertical",
                            {
                              attrs: {
                                required: _vm.$route.meta.char_pb_2_required,
                                label:
                                  _vm.$t(
                                    _vm.lblSetting.ticketNatureOfTheProblem
                                  ) + " 2"
                              }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  rules:
                                    _vm.dtRules
                                      .ticketFkTicketCharacterProblemsRules_2,
                                  "item-value": "id",
                                  "item-text": "name",
                                  items: _vm.characterProblems2,
                                  solo: ""
                                },
                                on: { change: _vm.handleChangeCharPb2 },
                                scopedSlots: _vm._u([
                                  {
                                    key: "selection",
                                    fn: function(data) {
                                      return _c(
                                        "v-chip",
                                        {
                                          staticClass: "chip--select-multi",
                                          attrs: {
                                            close: "",
                                            color: "secondary",
                                            "text-color": "whitePure"
                                          },
                                          on: { input: _vm.handleRemoveCharPb2 }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "multiple-selected-item",
                                              staticStyle: { width: "160px" }
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(data.item.name)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.FKTicketCharacterProblem2,
                                  callback: function($$v) {
                                    _vm.FKTicketCharacterProblem2 = $$v
                                  },
                                  expression: "FKTicketCharacterProblem2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(
                        "base-control-label-vertical",
                        {
                          attrs: {
                            required: "",
                            label: _vm.lblSetting.ticketNatureOfTheProblem
                          }
                        },
                        [
                          _c("ticket-nature-problem", {
                            attrs: { source: _vm.characterProblems.level_1 },
                            on: { onChange: _vm.handleChangeCharPb1 },
                            model: {
                              value: _vm.FKTicketCharacterProblem,
                              callback: function($$v) {
                                _vm.FKTicketCharacterProblem = $$v
                              },
                              expression: "FKTicketCharacterProblem"
                            }
                          })
                        ],
                        1
                      )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.select_ticket_equipment && _vm.FkTicketBlock
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    required: _vm.$route.meta.equipment_required,
                    label:
                      "" +
                      _vm.$t(_vm.lblSetting.ticketEquipment) +
                      (_vm.$route.meta.equipment_multiple ? "(s)" : "")
                  }
                },
                [
                  _c("base-multi-select", {
                    attrs: {
                      rules: _vm.equipmentRules,
                      options: _vm.coEquipments,
                      itemSubtext: "reference",
                      "return-object": false,
                      multiple: _vm.$route.meta.equipment_multiple,
                      fetch: _vm.handleGetEquipments,
                      icon: "handyman"
                    },
                    on: { change: _vm.handleChangeEquipment },
                    model: {
                      value: _vm.FKTicketEquipment,
                      callback: function($$v) {
                        _vm.FKTicketEquipment = $$v
                      },
                      expression: "FKTicketEquipment"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.meta.report_description
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    required: _vm.$route.meta.report_description_required,
                    label: _vm.lblSetting.ticketDescriptionOfTheProblem
                  }
                },
                [
                  _c("v-textarea", {
                    attrs: {
                      name: "description",
                      counter: _vm.textConfigs.textarea,
                      maxlength: _vm.textConfigs.textarea,
                      rows: 4,
                      required: "",
                      solo: "",
                      rules: _vm.dtRules.descriptionRules
                    },
                    model: {
                      value: _vm.Description,
                      callback: function($$v) {
                        _vm.Description = $$v
                      },
                      expression: "Description"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-3": "", xs12: "", md4: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("3")]),
                _vm._v(" "),
                _c("div", { staticClass: "secondary--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [_vm._v("Options")])
            ],
            1
          ),
          _vm._v(" "),
          _vm.contractors &&
          _vm.$route.meta.mandate &&
          _vm.$route.meta.ask_quote
            ? _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.ticketAddASpeaker } },
                [
                  _c("ticket-group-round-buttons", {
                    attrs: {
                      buttons: _vm.addASpeakers,
                      disabled: _vm.toUpdate
                    },
                    model: {
                      value: _vm.IsMandate,
                      callback: function($$v) {
                        _vm.IsMandate = $$v
                      },
                      expression: "IsMandate"
                    }
                  }),
                  _vm._v(" "),
                  _c("mandate-quote-selector", {
                    attrs: {
                      isMandate: _vm.IsMandate,
                      disabled: _vm.toUpdate,
                      block: _vm.FkTicketBlock
                    },
                    model: {
                      value: _vm.MandatesOrQuoteTk,
                      callback: function($$v) {
                        _vm.MandatesOrQuoteTk = $$v
                      },
                      expression: "MandatesOrQuoteTk"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.ticketAttachDocuments } },
            [
              _c("ticket-upload-buttons-new", {
                attrs: {
                  "custom-class": "upload-buttons",
                  creator: _vm.dtAttachmentCreator,
                  disabled: _vm.toUpdate
                },
                model: {
                  value: _vm.vAttachments,
                  callback: function($$v) {
                    _vm.vAttachments = $$v
                  },
                  expression: "vAttachments"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta.ticket_availability_mileage &&
          _vm.showMileageAvailability
            ? _c(
                "div",
                { staticClass: "mt-4" },
                [
                  _c(
                    "base-control-label-vertical",
                    { attrs: { label: _vm.lblSetting.ticketVehicleMileage } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "0",
                          type: "number",
                          solo: "",
                          suffix: "KM"
                        },
                        model: {
                          value: _vm.mileage,
                          callback: function($$v) {
                            _vm.mileage = $$v
                          },
                          expression: "mileage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: { label: _vm.lblSetting.ticketVehicleAvailability }
                    },
                    [
                      _c("v-text-field", {
                        attrs: { type: "text", solo: "" },
                        model: {
                          value: _vm.availability,
                          callback: function($$v) {
                            _vm.availability = $$v
                          },
                          expression: "availability"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9d86dae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9d86dae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-modal-vertical/template.html
// module id = null
// module chunks = 